const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.415,4.584A10.488,10.488,0,0,0,3.889,18.652a3.94,3.94,0,0,1-1.652,1.911.978.978,0,0,0,.281,1.845,5.012,5.012,0,0,0,.743.057h0A6.779,6.779,0,0,0,7.03,21.244,10.492,10.492,0,0,0,19.415,4.584Zm-.839,13.993A9.306,9.306,0,0,1,7.289,20.022a.591.591,0,0,0-.663.04A5.649,5.649,0,0,1,3.335,21.27a5.957,5.957,0,0,0,1.8-2.482.6.6,0,0,0-.1-.633,9.3,9.3,0,1,1,13.545.422Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.393,8.538H7.606a.593.593,0,0,0,0,1.186h8.787a.593.593,0,0,0,0-1.186Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.393,11.407H7.606a.593.593,0,0,0,0,1.186h8.787a.593.593,0,0,0,0-1.186Z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.393,14.276H7.606a.593.593,0,0,0,0,1.186h8.787a.593.593,0,0,0,0-1.186Z",
    style: {
      fill: "#FFFFFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.7b4111a613a56fe522b0b61d639e7b32.svg";
export { ForwardRef as ReactComponent };